import { takeLatest } from 'redux-saga/effects';
import {
  getAccessRightListSuccess, getAccessRightListFail,
  getAccessRightDetailsSuccess, getAccessRightDetailsFail
} from './accessRightState';
import createCrudService from '../../services/crudservice';
import { doCrudCall, SAVING_MSG, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
	createRecordSuccess, updateRecordSuccess, deleteRecordSuccess 
	} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/security/access-rights');
const redirectData = {route:'/console/access-rights', mode: 'list', recordId:0 };
const modelName = 'Access Right';
const modelId = 'acr_id';

function* getAccessRightList(data) {
	yield doCrudCall(
		() => crudService.getList(data.payload), 
		getAccessRightListSuccess, 
		getAccessRightListFail,
		null, null, LOADING_MSG);
}

function* getAccessRightDetails(data) {
	yield doCrudCall(
		() => crudService.getDetails(data.payload), 
		getAccessRightDetailsSuccess, 
		getAccessRightDetailsFail,
		null, null, LOADING_MSG);		
}

function* doAccessRightCreate(data){
	yield doCrudCall(
		() => crudService.doCreate(data.payload), 
		getAccessRightDetailsSuccess, 
		getAccessRightDetailsFail,
		createRecordSuccess(modelName),
		redirectData, SAVING_MSG);
}

function* doAccessRightUpdate(data){
	yield doCrudCall(
		() => crudService.doUpdate(data.payload[modelId], data.payload), 
		getAccessRightDetailsSuccess, 
		getAccessRightDetailsFail,
		updateRecordSuccess(modelName),
		redirectData, UPDATING_MSG);	
}

function* doAccessRightDelete(data){
	yield doCrudCall(
		() => crudService.doDelete(data.payload.recordId), 
		getAccessRightDetailsSuccess, 
		getAccessRightDetailsFail,
		deleteRecordSuccess(modelName),
		{...redirectData, mode: data.payload.mode},
		DELETING_MSG);	
}

function* accessRightSaga() {
  yield takeLatest('accessRight/getAccessRightList', getAccessRightList);
  yield takeLatest('accessRight/getAccessRightDetails', getAccessRightDetails);
  yield takeLatest('accessRight/doAccessRightCreate', doAccessRightCreate);
  yield takeLatest('accessRight/doAccessRightUpdate', doAccessRightUpdate);
  yield takeLatest('accessRight/doAccessRightDelete', doAccessRightDelete);  
}

export default accessRightSaga;
